import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface MessagePopupData {
  header: string;
  message: string;
  icon?: string;
  iconColor?: string;
}

@Component({
  selector: 'app-generic-message-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  template: `
    <div class="message-popup-container">
      <h2 mat-dialog-title class="perse-dialog-title">
        {{ data.header }}
      </h2>
      <mat-dialog-content>
        @if (data.icon) {
          <div class="icon-container">
            <mat-icon [style.color]="data.iconColor || 'var(--mat-sys-primary)'" class="popup-icon">
              {{ data.icon }}
            </mat-icon>
          </div>
        }
        <p class="message-text">{{ data.message }}</p>
      </mat-dialog-content>
      <!-- <mat-dialog-actions align="end">
        <button mat-button color="primary" (click)="onClose()" cdkFocusInitial>
          OK
        </button>
      </mat-dialog-actions> -->
    </div>
  `,
  styles: [`
    .message-popup-container {
      min-width: 300px;
      text-align: center;
    }
    
    .icon-container {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }
    
    .popup-icon {
      font-size: 48px !important;
      width: 48px !important;
      height: 48px !important;
    }
    
    .message-text {
      margin: 0;
      line-height: 1.5;
      color: var(--mat-sys-on-surface);
    }
    
    mat-dialog-actions {
      padding: 16px 0 0 0;
    }
  `]
})
export class GenericMessagePopupComponent {
  constructor(
    public dialogRef: MatDialogRef<GenericMessagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessagePopupData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
